<template>
    <!-- 404页面 -->
  <div class="wscn-http404-container">
    <!-- <button @click='encrypt'>加密</button>
    <button @click='decrypt'>解密</button> -->
    <div class="wscn-http404">
      <div class="pic-404">
        <img class="pic-404__parent" src="@/assets/img/404.png" alt="404">
        <img class="pic-404__child left" src="@/assets/img/404_cloud.png" alt="404">
        <img class="pic-404__child mid" src="@/assets/img/404_cloud.png" alt="404">
        <img class="pic-404__child right" src="@/assets/img/404_cloud.png" alt="404">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      srt: "z9MNcoQ9YL9HBTFQocgXB3tHrKv2ZRb1eYN5ycrW8Rbpf5Z+0BhR/8Ta7LfwOpTId51L3Ji/lsriYFZKAZ5p4+COqpcxsynqlloHVNdPeG0="
    }
  },
  mounted() {
    
  },
  methods: {
    // 加密  把账号、密码、时间加密为密文
    encrypt() {
     let obj = {
       user: "wrs01@email.com",     // 账号
       pwd: "wrs01@2021",         // 密码
       time: new Date()*1    // 当前时间戳
     }
     let iv = JSON.stringify(obj)   // 转换成字符串
     // 参数一：加密的数据
      // 参数二：秘钥（加解密要保持秘钥一致）
      this.srt = this.$crypto.encrypt(iv,"syzh&wrs2021"); // P3WJa9E8gmu2vXpyt6yI8+vJBU4fUgSooeSxEs4raDO52XOJ/baZpcS2Kq2FV2aik6RkibGnCsmOmdsbH5tBLA==
      console.log(this.srt)
    },

    // 解密  从密文获取账号、密码、时间
    decrypt() {
      // 参数一：密文
      // 参数二：秘钥（加解密要保持秘钥一致）
      let data = this.$crypto.decrypt(this.srt,"syzh&wrs2021");
      console.log(JSON.parse(data))  // {user: "sy123456", pwd: "45678", time: 1614220882079}
    },
  }
}
</script>

<style lang="scss" scoped>
.wscn-http404-container{
  transform: translate(-50%,-50%);
  position: absolute;
  top: 40%;
  left: 50%;
}
.wscn-http404 {
  position: relative;
  padding: 0 50px;
  overflow: hidden;
  .pic-404 {
    position: relative;
    float: left;
    width: 600px;
    overflow: hidden;
    &__parent {
      width: 100%;
    }
    &__child {
      position: absolute;
      &.left {
        width: 80px;
        top: 17px;
        left: 220px;
        opacity: 0;
        animation-name: cloudLeft;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
        animation-delay: 1s;
      }
      &.mid {
        width: 46px;
        top: 10px;
        left: 420px;
        opacity: 0;
        animation-name: cloudMid;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
        animation-delay: 1.2s;
      }
      &.right {
        width: 62px;
        top: 100px;
        left: 500px;
        opacity: 0;
        animation-name: cloudRight;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
        animation-delay: 1s;
      }
      @keyframes cloudLeft {
        0% {
          top: 17px;
          left: 220px;
          opacity: 0;
        }
        20% {
          top: 33px;
          left: 188px;
          opacity: 1;
        }
        80% {
          top: 81px;
          left: 92px;
          opacity: 1;
        }
        100% {
          top: 97px;
          left: 60px;
          opacity: 0;
        }
      }
      @keyframes cloudMid {
        0% {
          top: 10px;
          left: 420px;
          opacity: 0;
        }
        20% {
          top: 40px;
          left: 360px;
          opacity: 1;
        }
        70% {
          top: 130px;
          left: 180px;
          opacity: 1;
        }
        100% {
          top: 160px;
          left: 120px;
          opacity: 0;
        }
      }
      @keyframes cloudRight {
        0% {
          top: 100px;
          left: 500px;
          opacity: 0;
        }
        20% {
          top: 120px;
          left: 460px;
          opacity: 1;
        }
        80% {
          top: 180px;
          left: 340px;
          opacity: 1;
        }
        100% {
          top: 200px;
          left: 300px;
          opacity: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/404.vue